module.exports = __webpack_public_path__ + "static/media/tr.a112d298.svg";